import { Suspense, useEffect, useRef, useState } from "react";
import Buttons from "../../../../components/ui/button/Buttons";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import FormCreator from "../../../../components/Forms/FormCreator";
import SwalAlert from "../../../../services/swalService/SwalService";
import PageLoader from "../../../../components/ui/pageLoader/PageLoader";
import { useResetPasswordOtherRepresentativeMutation } from "../../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { ResetPasswordData } from "./Data/ResetPasswordForm.Data";

const ResetPasswordModel = (props) => {
    const updateFormRef = useRef();
    const [formData, setFormData] = useState(ResetPasswordData);
    const { success, error } = SwalAlert();
    const [updatePassword, { isLoading: isLoading, isSuccess: isSuccess, data: updatePasswordRes }] = useResetPasswordOtherRepresentativeMutation();

    useEffect(() => {
        if (!isLoading && isSuccess && updatePasswordRes) {        
            props.handleClose();
            success("Your Password has been successfully Updated");
        }
    }, [isLoading, isSuccess, updatePasswordRes]);

    const handleUpdatePassword = () => {
        const formData = updateFormRef.current?.getFormData();
        if (!formData) return;
        if (formData?.password === formData?.confirmPassword) {
            const request = {
               RepresntativeId: props.selectedRepresentative?.representativeId || null,
               Password: formData.password || null,
            };
            updatePassword(request);            

        } else {
            error("The passwords do not match. Please try again.", "");
        }
    }

    return (
        <div className="col-12 d-flex justify-content-end mt-4">
            <div clasName="reset-password-button">

                <CenterModel
                    modelTitle={"modelDetail.label "}
                    show={props.show}
                    handleClose={props.handleClose}
                    onUpload={props.handleClose}
                >
                    <div className='container resetPasswordForm'>
                        <div className='row d-flex justify-content-center'>
                            <div className='col-lg-6 resetPasswordCard py-4 my-5'>
                                <h1 className='text-center'>Update Password</h1>
                                <h6 className='text-center'>Enter new password to retrieve your account</h6>
                                <hr />
                                <div className='p-4'>
                                    <p class="lead">Password must be at least 6 alphanumeric characters and contain at least one uppercase, one special character such as @#$%</p>
                                    <Suspense fallback={<PageLoader />}>
                                        <FormCreator
                                            ref={updateFormRef}
                                            {...formData}
                                        />
                                        <div className='col-lg-12 mt-3'>
                                            <Buttons
                                                buttonTypeClassName="btn success-btn"
                                                buttonText="Reset Your Password"
                                                onClick={handleUpdatePassword}
                                                isLoading={isLoading}
                                            />
                                        </div>
                                    </Suspense>
                                </div>
                            </div>
                        </div>
                    </div>
                </CenterModel>
            </div>
        </div>
    )
};

export default ResetPasswordModel;
